// Create a Providers component to wrap your application with all the components requiring 'use client', such as next-nprogress-bar or your different contexts...
'use client';

import { ProgressProvider } from '@bprogress/next/app';
import { ReactNode } from 'react';
import '@/styles/progress-bar.css';

/* 
nprogess-bar library adds styles defined inside nprogress.css only if we add style prop.
Seperate css file is required for progress bar to take org theme color.
*/

const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <ProgressProvider color="#542CC2" height="4px" options={{ showSpinner: false }}>
      {children}
    </ProgressProvider>
  );
};

export default Providers;
